// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-k_gM","advertDetailHeaderPrice__value":"c-k_gN","advertDetailHeaderPrice__label":"c-k_gO"};